/* eslint-disable no-console */
import { ErrorInfo, FC, lazy, ReactNode, Suspense } from 'react';
import { CoreBox } from '@youscience/core';
import { MAIN_LOGO_PATH } from '@constants';
import { UNAUTHORIZED_LAYOUT_TESTID } from '@layouts/layout.testIds';
import { FooterFallback } from '@components/RemoteMicroFrontends/fallbacks';
import { FederatedErrorBoundary } from '@components/RemoteMicroFrontends/FederatedErrorBoundary';
import { SignInPageContainer, ContentWrapper, ChildContainer } from './UnauthorizedLayout.styles';

const Footer = lazy(() => import('brightpathHeader/Footer'));

export const UnauthorizedLayout: FC<{ children?: ReactNode; signIn?: VoidFunction }> = ({ children, signIn }) => {
  signIn?.();

  return (
    <SignInPageContainer data-testid={UNAUTHORIZED_LAYOUT_TESTID}>
      <ContentWrapper>
        <ChildContainer>
          <img
            alt='YouScience logo'
            height='60px'
            loading='lazy'
            src={MAIN_LOGO_PATH}
            style={{ marginBottom: 100 }}
            width='200px'
          />
          <CoreBox>{children}</CoreBox>
        </ChildContainer>
      </ContentWrapper>
      <Suspense fallback={null}>
        <FederatedErrorBoundary
          moduleName='brightpathFooter'
          fallback={<FooterFallback />}
          onError={(error: Error, errorInfo: ErrorInfo) => {
            console.error('Failed to load Footer:', error);
            console.error('Error Info:', errorInfo);
          }}
        >
          <Footer />
        </FederatedErrorBoundary>
      </Suspense>
    </SignInPageContainer>
  );
};
